import { render, staticRenderFns } from "./markets_new.vue?vue&type=template&id=57d059f4&"
import script from "./markets_new.vue?vue&type=script&lang=js&"
export * from "./markets_new.vue?vue&type=script&lang=js&"
import style0 from "./markets_new.vue?vue&type=style&index=0&id=57d059f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports